<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <ejs-splitbutton
            v-bind="syncfusionConfig"
            :content="config.content || config.label"
            :cssClass="config.cssClass || 'preview-link'"
            v-on:click="action($event, 'onclick')"
            v-on:select="action($event, 'onselect')"
            :ref="config.ref || config.id"
            :data-test-id="dataTestId"
            :disabled="config.disabled"
        ><div></div>
        </ejs-splitbutton>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

export const splitButtonComponent = {
    mixins: [controlMixins],
    components: {
        "ejs-splitbutton": defineAsyncComponent(() => import('@common/syncfusion/splitButton'))
    }
};

export default splitButtonComponent;
</script>
